import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fromJS, Map } from "immutable";

import { isMapContain } from "fe-shared/utils/global";

import apiConversation from "api/conversation";
import { setTokenForAPI } from "api/base";
import Spinner from "components/atoms/Spinner";
import { getQueryVariable, getCvars } from "utils/index";
import { getIsAuthenticated } from "api/authentication";
import configActions from "actions/config";
import persistentMenuActions from "actions/persistentMenu";
import webbotActions from "actions/webbot";
import webviewActions from "actions/webview";
import communicationConfigActions from "actions/communicationConfig";
import { getConfigDataStyles } from "reducers/config";
import { getWebviewIsInputDisabled } from "reducers/webview";
import { STATE_WEBBOT_ALL_MESSAGES } from "reducers/webbot/default";
import {
  getWebbotIsRestartingChat,
  getWebbotVisibleMessages,
  getCVarsValue,
} from "reducers/webbot";
import { encodeString } from "utils";
import { removeLocalStorage, checkStorageAvailability } from "utils/storage";
import { adaptAllMessageForLocalStorage } from "utils/dataHandling";
import { isBotxoDomain, createWebInfoToScript } from "utils/rebranding";

//CONTAINERS
import ChatV2 from "./v2/Chat";

import myStyles from "./chat.cssmodule.scss";
import {
  initWidget,
  POST_MESSAGE_EDITOR_GET_AUTH,
  POST_MESSAGE_SCRIPT_GET_CONFIGURATION,
} from "./utils";

const modesToClearPastConversations = ["testing", "clear_past_conversations"];

const isPrevDomain = isBotxoDomain();

const Chat = props => {
  const {
    location,
    styles,
    isInputDisabled,
    isRestartingChat,
    messages,
    cvarsValue,
    match: {
      params: { id },
    },
    actions: {
      getConfig,
      getConfigAndMakeConnection,
      isInputDisabled: isInputDisabledAction,
      updateConfigData,
      saveWebchatData,
      startWebsocket,
      restartWebsocket,
    },
  } = props;

  const showPreviousConversations = styles.getIn(
    ["widget", "showPreviousConversations"],
    true
  );

  const isBotEnabled = styles.get("isEnabled", true);

  const userId = getQueryVariable("user_id", location.search);
  const referral = getQueryVariable("ref", location.search);
  const testing =
    modesToClearPastConversations.includes(
      getQueryVariable("mode", location.search)
    ) || !showPreviousConversations;
  const newChannel = getQueryVariable("newchannel", location.search);
  const noDelayMode = getQueryVariable("no_delay_mode", location.search);
  const webchatKey = getQueryVariable("webchatKey", location.search);
  const pathname = getQueryVariable("pathname", location.search);
  const cvars = getCvars(getQueryVariable("cvars", location.search));
  const origin = getQueryVariable("origin", location.search);
  const autoLoad = getQueryVariable("autoload", location.search) === "true";
  const isDebuggerMode =
    getQueryVariable("debuggerMode", location.search) === "1";
  const isPreview = getQueryVariable("isPreview", location.search) === "1";
  const botId = getQueryVariable("botId", location.search);
  const moduleId = getQueryVariable("module_id", location.search);
  const versionName = getQueryVariable("version_name", location.search);
  const userIdChat = getQueryVariable("uId", location.search);
  const voiceEnabled = getQueryVariable("voiceEnabled", location.search);

  const [isWebsocketCreated, setIsWebsocketCreated] = useState(true);
  const [isLoadingPreviousConversations, setIsLoadingPreviousConversations] =
    useState(!!userIdChat);

  const isFromWidgetScript =
    getQueryVariable("from_script", location.search) === "1";
  const isFromEditor = getQueryVariable("from_editor", location.search) === "1";

  const [loadingWidget, setLoadingWidget] = React.useState(false);
  const [scriptWidgetConfig, setScriptWidgetConfig] = React.useState(null);

  const [jwt, setJwt] = React.useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const defaultWeb = createWebInfoToScript();
  const dataToWebsocket = {
    id,
    userId,
    referral,
    testing,
    origin,
    newChannel,
    noDelayMode,
    cvars,
    webchatKey,
    voiceEnabled,
    web: !isFromEditor && !isFromWidgetScript ? defaultWeb : undefined,
  };

  const dataToResetConversation = {
    id: botId,
    module_id: moduleId,
    version_name: versionName,
  };

  const startChat = (actionToInitWidget, wsData) => {
    actionToInitWidget({
      ...wsData,
      autoLoad,
    });
    setIsLoadingPreviousConversations(false);
  };

  const initializeWidgetConfig = (actionToInitWidget, wsData) => {
    const localStorageAvailability = checkStorageAvailability("localStorage");

    if (autoLoad) {
      setIsWebsocketCreated(false);
      isInputDisabledAction(true);
    }

    if (localStorageAvailability && isLoadingPreviousConversations) {
      webbotActions.removeLocalStorage(id, webchatKey);
      apiConversation
        .getConversation({ id: userIdChat, bot_deployment_id: id })
        .then(data => {
          try {
            const allMessages = data && data.toJS();
            if (allMessages && allMessages.length) {
              localStorage.setItem(
                `${encodeString(`userId-${id}-${webchatKey}`)}`,
                encodeString(userIdChat)
              );
              localStorage.setItem(
                `${encodeString(`botId-${id}-${webchatKey}`)}`,
                encodeString(id)
              );
              localStorage.setItem(
                `${encodeString(
                  `${STATE_WEBBOT_ALL_MESSAGES}${id}-${webchatKey}`
                )}`,
                encodeString(
                  JSON.stringify(
                    adaptAllMessageForLocalStorage({ allMessages, webchatKey })
                  )
                )
              );
            }
          }
          catch (e) {
            console.log("Local Storage is full, Please empty data");
          }
          startChat(actionToInitWidget, wsData);
        })
        .catch(() => {
          webbotActions.removeLocalStorage(id, webchatKey);
          startChat(actionToInitWidget, wsData);
        });
    } else {
      actionToInitWidget({
        ...wsData,
        autoLoad,
      });
    }

    saveWebchatData(
      Map({
        webchatKey,
        origin,
        pathname,
        isDebuggerMode,
      })
    );
  };

  useEffect(() => {
    if (testing) {
      localStorage.setItem("isClearPastConversation", 1);
    } else {
      localStorage.removeItem("isClearPastConversation");
    }
  }, [testing])

  useEffect(() => {
    if (!isFromWidgetScript && !isFromEditor) {
      initializeWidgetConfig(getConfigAndMakeConnection, dataToWebsocket);
    } else {
      getConfig(dataToWebsocket);
    }
  }, [isFromWidgetScript, isFromEditor]);

  useEffect(() => {
    initWidget();

    if (isFromWidgetScript || isFromEditor) {
      setLoadingWidget(true);
    }

    window.addEventListener("message", ({ data }) => {
      switch (data.type) {
        case POST_MESSAGE_EDITOR_GET_AUTH: {
          const { message: editorAuth } = data;

          setJwt(editorAuth);
          break;
        }
        case POST_MESSAGE_SCRIPT_GET_CONFIGURATION: {
          const { message: scriptConfiguration } = data;

          setScriptWidgetConfig(scriptConfiguration);
          break;
        }
        default:
          break;
      }
    });
  }, [isFromWidgetScript, isFromEditor]);

  useEffect(() => {
    const canUpdateConfig =
      (isFromWidgetScript || isFromEditor) &&
      loadingWidget &&
      isMapContain(styles) &&
      !!scriptWidgetConfig;

    if (canUpdateConfig) {
      const { chatMessage, web } = scriptWidgetConfig;

      //Modify styles state when chatMessage is added from script but not from editor
      if (!isFromEditor) {
        updateConfigData({
          path: ["styles", "chatMessage"],
          value: fromJS(chatMessage),
        });
      }

      //Send new data to WS Connection once the config has been received and widget is ready
      initializeWidgetConfig(startWebsocket, {
        ...dataToWebsocket,
        web,
      });

      setLoadingWidget(false);
    }
  }, [
    isFromWidgetScript,
    isFromEditor,
    loadingWidget,
    styles,
    scriptWidgetConfig,
  ]);

  useEffect(() => {
    if (jwt) {
      setTokenForAPI(jwt);
      getIsAuthenticated().then(() => {
        setIsAuthenticated(true);
      });
    }
  }, [jwt]);

  const eventClickInput = () => {
    if (isInputDisabled && !isWebsocketCreated) {
      setIsWebsocketCreated(true);
      startWebsocket(dataToWebsocket);
      isInputDisabledAction(false);
    }
  };

  const resetChat = (CVARS = null) => {
    const { web: webCvars } = scriptWidgetConfig;

    removeLocalStorage(id, webchatKey);
    window.top.postMessage({ message: "button-reset-chat" }, "*");
    dataToWebsocket.web = webCvars ?? defaultWeb;
    dataToWebsocket.cvars = CVARS
      ? JSON.parse(CVARS)
      : CVARS !== null && CVARS.length === 0
      ? {}
      : cvarsValue.length > 0
      ? JSON.parse(cvarsValue)
      : {};

    if (!isRestartingChat && messages && messages.size) {
      restartWebsocket({
        dataToWebsocket,
        dataToResetConversation,
        forceReset: true,
      });
    }
  };

  if (
    isLoadingPreviousConversations ||
    !isMapContain(styles) ||
    (isFromWidgetScript && loadingWidget)
  ) {
    return (
      <div
        className={
          isPrevDomain ? myStyles.spinnerContainer : myStyles.ndSpinnerContainer
        }
      >
        <Spinner />
      </div>
    );
  }

  // Stop the build flow of the bot when it isnt enabled
  // eslint-disable-next-line consistent-return
  if (!isBotEnabled) return;

  return (
    <ChatV2
      {...props}
      {...{ eventClickInput, isPreview, resetChat, isAuthenticated }}
      botId={botId || id}
    />
  );
};

Chat.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  styles: ImmutablePropTypes.map,
  actions: PropTypes.shape({
    getConfigAndMakeConnection: PropTypes.func,
    isInputDisabled: PropTypes.func,
    saveWebchatData: PropTypes.func,
    startWebsocket: PropTypes.func,
    restartWebsocket: PropTypes.func,
  }).isRequired,
  isInputDisabled: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  isRestartingChat: PropTypes.bool,
  messages: ImmutablePropTypes.list.isRequired,
  cvarsValue: PropTypes.string,
};

const mapStateToProps = state => ({
  styles: getConfigDataStyles(state),
  isInputDisabled: getWebviewIsInputDisabled(state),
  isRestartingChat: getWebbotIsRestartingChat(state),
  messages: getWebbotVisibleMessages(state),
  cvarsValue: getCVarsValue(state),
});

const mapDispatchToProps = dispatch => {
  const actions = {
    ...webbotActions,
    ...configActions,
    ...persistentMenuActions,
    ...webviewActions,
    ...communicationConfigActions,
  };
  return { actions: bindActionCreators(actions, dispatch) };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
